export enum types {
  ROLE_GET_ALL = 'role/getAll',
  ROLE_GET_BY_ID = 'role/getById',
  ROLE_CREATE = 'role/create',
  ROLE_UPDATE = 'role/update',
  ROLE_DELETE = 'role/delete',
  ROLE_GET_ALL_PERMISSIONS = 'role/getAllPermissions',
}
